import { render } from "./SaveTemplate.vue?vue&type=template&id=08d33c1c&scoped=true&ts=true"
import script from "./SaveTemplate.vue?vue&type=script&lang=ts"
export * from "./SaveTemplate.vue?vue&type=script&lang=ts"

import "./SaveTemplate.vue?vue&type=style&index=0&id=08d33c1c&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d33c1c"]])

export default __exports__